export default __webpack_public_path__ + "images/a05011bff44fd0d1a514d879e4575422.png";